import React, { Fragment } from "react";
import { Helmet } from 'react-helmet';
import { Link } from "react-router-dom";
import "./css/servicios.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import BannerDatos from "../../images/servicio/bg-cloud.webp";
import BannerDatosmobile from "../../images/servicio/bg-cloud-m.webp";

function InfoManual() {
  return (
    <Fragment>
      <Container fluid={true} className="banner-servicios">
        <Row>
          <Col md={12} className="px-0">
            <Helmet>
              <link rel="preload" href={BannerDatos} as="image" />
            </Helmet>
            <Card>
              <img
                src={BannerDatos}
                alt="Hyundai Banner"
                className="card-bannerdatos"
              />
              <Card.Img
                src={BannerDatosmobile}
                alt="Hyundai Banner"
                className="d-block d-sm-none"
              />
              <Card.ImgOverlay className="d-flex">
                <Card.Title className="bg-banner-servicios w-100 d-flex align-items-center">
                  <div className="mx-auto w-100">
                    <h1 className="servicios-banner-titulo">
                      Manual del propietario.
                    </h1>
                    <br />
                    <h2 className="servicios-banner-subtitulo">
                      Mantenga su valioso coche de forma segura durante mucho
                      tiempo con el mantenimiento programadado de Hyundai.
                    </h2>
                  </div>
                </Card.Title>
              </Card.ImgOverlay>
            </Card>
          </Col>
        </Row>
      </Container>
      <Container className="mb-5 pb-3 mt-4 mantenimiento mantenimiento-group">
        <Row>
          <Col xs={6} className="px-0">
            <Link
              to="/mantenimiento"
              className="text-reset text-decoration-none"
            >
              <Button variant="secondary" block>
                Mantenimiento
              </Button>
            </Link>
          </Col>
          <Col xs={6} className="px-0">
            <Button variant="secondary" className="btn-active" block>
              Manual del propietario
            </Button>
          </Col>
        </Row>
      </Container>
      <Container className="mb-5 pb-3 mt-4 tabla-manual">
        <Row>
          <Col className="table-cont" md={12}>
            <Table responsive bordered hover>
              <thead>
                <tr>
                  <th>Vehículo</th>
                  <th>Tipo</th>
                  <th>Manual</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>All New Accent</td>
                  <td>Auto</td>
                  <td>
                    <a
                      href="https://kerner.hyundai.com.ec/documentos/manuales/manual-propietario-accent22.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="manual-link"
                    >
                      <FontAwesomeIcon icon={faDownload} /> Descargar
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>All New Tucson</td>
                  <td>SUV</td>
                  <td>
                    <a
                      href="https://kerner.hyundai.com.ec/documentos/manuales/manual-propietario-tucson22.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="manual-link"
                    >
                      <FontAwesomeIcon icon={faDownload} /> Descargar
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>New Kona</td>
                  <td>SUV</td>
                  <td>
                    <a
                      href="https://kerner.hyundai.com.ec/documentos/manuales/manual-propietario-kona22.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="manual-link"
                    >
                      <FontAwesomeIcon icon={faDownload} /> Descargar
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>All New Creta ES</td>
                  <td>SUV</td>
                  <td>
                    <a
                      href="https://kerner.hyundai.com.ec/documentos/manuales/manual-propietario-creta22.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="manual-link"
                    >
                      <FontAwesomeIcon icon={faDownload} /> Descargar
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Grand i10</td>
                  <td>Auto</td>
                  <td>
                    <a
                      href="https://kerner.hyundai.com.ec/documentos/manuales/manual-propietario-grand10.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="manual-link"
                    >
                      <FontAwesomeIcon icon={faDownload} /> Descargar
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>New Grand i10 Sedan</td>
                  <td>Auto</td>
                  <td>
                    <a
                      href="https://kerner.hyundai.com.ec/documentos/manuales/manual-propietario-grand10sd.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="manual-link"
                    >
                      <FontAwesomeIcon icon={faDownload} /> Descargar
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>New IONIQ</td>
                  <td>Auto</td>
                  <td>
                    <a
                      href="https://kerner.hyundai.com.ec/documentos/manuales/manual-propietario-ioniq22.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="manual-link"
                    >
                      <FontAwesomeIcon icon={faDownload} /> Descargar
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>All New Santa Fe</td>
                  <td>SUV</td>
                  <td>
                    <a
                      href="https://kerner.hyundai.com.ec/documentos/manuales/manual-propietario-santafe22.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="manual-link"
                    >
                      <FontAwesomeIcon icon={faDownload} /> Descargar
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Sonata</td>
                  <td>Auto</td>
                  <td>
                    <a
                      href="https://kerner.hyundai.com.ec/documentos/manuales/manual-propietario-sonata.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="manual-link"
                    >
                      <FontAwesomeIcon icon={faDownload} /> Descargar
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Venue</td>
                  <td>SUV</td>
                  <td>
                    <a
                      href="https://kerner.hyundai.com.ec/documentos/manuales/manual-propietario-venue.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="manual-link"
                    >
                      <FontAwesomeIcon icon={faDownload} /> Descargar
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Tucson</td>
                  <td>SUV</td>
                  <td>
                    <a
                      href="https://kerner.hyundai.com.ec/documentos/manuales/manual-propietario-tucson.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="manual-link"
                    >
                      <FontAwesomeIcon icon={faDownload} /> Descargar
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Staria</td>
                  <td>VAN</td>
                  <td>
                    <a
                      href="https://kerner.hyundai.com.ec/documentos/manuales/manual-propietario-staria.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="manual-link"
                    >
                      <FontAwesomeIcon icon={faDownload} /> Descargar
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Creta EN</td>
                  <td>SUV</td>
                  <td>
                    <a
                      href="https://kerner.hyundai.com.ec/documentos/manuales/manual-propietario-creta-2024.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="manual-link"
                    >
                      <FontAwesomeIcon icon={faDownload} /> Descargar
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Tucson (Gasolina / Híbrido)</td>
                  <td>SUV</td>
                  <td>
                    <a
                      href="https://kerner.hyundai.com.ec/documentos/manuales/manual-propietario-tucson25.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="manual-link"
                    >
                      <FontAwesomeIcon icon={faDownload} /> Descargar
                    </a>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}
export default InfoManual;